import { Route } from '@angular/router';
import { gamesLocalLeaveBusterGuard } from 'src/app/modules/games/guards/games-local-leave-buster.guard';

export const doublesTrainingLocalGameRoutes: Route[] = [
    {
        path: 'local-games/doubles-training',
        loadComponent: () =>
            import('./pages/doubles-training-new-game/doubles-training-new-game.component').then(
                (c) => c.DoublesTrainingNewGameComponent
            ),
    },
    {
        path: 'game/doubles-training',
        canDeactivate: [gamesLocalLeaveBusterGuard],
        loadComponent: () =>
            import('./pages/doubles-training-local-game-app/doubles-training-local-game-app.component').then(
                (m) => m.DoublesTrainingLocalGameAppComponent
            ),
    },
];

export const doublesTrainingVenueLocalGameRoutes: Route[] = [
    {
        path: 'local-games/doubles-training',
        loadComponent: () =>
            import('./pages/doubles-training-new-game/doubles-training-new-game.component').then(
                (c) => c.DoublesTrainingNewGameComponent
            ),
    },
    {
        path: 'game/doubles-training',
        canDeactivate: [gamesLocalLeaveBusterGuard],
        loadComponent: () =>
            import('./pages/doubles-training-local-game-venue/doubles-training-local-game-venue.component').then(
                (m) => m.DoublesTrainingLocalGameVenueComponent
            ),
    },
];
